import { PointPicker } from "@majitap/ui";
import { Input } from "@majitap/ui/arc/input/input";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { isCoordinate, toCoordinate } from "../../coordinates";
import { toMapZone, zonesListQuery } from "../../zones";
import styles from "./point-field.module.css";

// number-ok: coordinates to 6 places (about 10 cm), not money
export const asText = (n: number) => n.toFixed(6);

/**
 * Where a place or fill site is: click the map or drag the pin, or type the coordinates. The
 * zones show, so it's clear which one the point falls in (the database decides on save).
 */
export function PointField({
  lat,
  lng,
  onChange,
}: {
  lat: string;
  lng: string;
  onChange: (lat: string, lng: string) => void;
}) {
  const zones = useQuery(zonesListQuery);
  const mapZones = useMemo(() => (zones.data ?? []).map(toMapZone), [zones.data]);
  const value =
    isCoordinate(lat, 90) && isCoordinate(lng, 180) ? { lat: toCoordinate(lat), lng: toCoordinate(lng) } : null;
  return (
    <div className={styles.field}>
      <PointPicker value={value} zones={mapZones} onChange={(at) => onChange(asText(at.lat), asText(at.lng))} />
      <div className={styles.pair}>
        <Input
          label="Latitude"
          inputMode="decimal"
          value={lat}
          onChange={(e) => onChange(e.target.value, lng)}
          placeholder="-1.2921"
        />
        <Input
          label="Longitude"
          inputMode="decimal"
          value={lng}
          onChange={(e) => onChange(lat, e.target.value)}
          placeholder="36.8219"
        />
      </div>
    </div>
  );
}
